// Bridge to the native StepCounter plugin (reads the hardware step counter
// directly, no Samsung Health / Health Connect dependency). No-op on web.
let StepCounter = null
try {
  const { registerPlugin } = require('@capacitor/core')
  StepCounter = registerPlugin('StepCounter')
} catch (e) {}

export { StepCounter }
